import { Component } from '@angular/core';
import { Platform } from '@ionic/angular';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'radium-formly-wrapper',
  template: `
    <ion-item
      [title]="props?.attributes?.title ?? props?.label"
      [ngStyle]="{
        'font-size': isMobile && '12px',
        '--padding-start': isMobile && ' 1%'
      }"
    >
      <ion-label
        *ngIf="props.label && !props.hideLabel"
        [ngStyle]="{
          'margin-right': isMobile && '2px'
        }"
      >
        {{ props.label }}:
        <ng-container
          *ngIf="props?.required && props.hideRequiredMarker !== true"
          ><span style="color: red">*</span></ng-container
        >
      </ion-label>

      <div
        *ngIf="field.type === 'datetime'"
        style="width: 70%; text-align-last: right;"
      >
        <ng-template #fieldComponent></ng-template>
      </div>

      <ng-template
        *ngIf="field.type !== 'datetime'"
        #fieldComponent
      ></ng-template>

      <!--      <ion-icon-->
      <!--        slot="end"-->
      <!--        name="checkmark-circle-outline"-->
      <!--        *ngIf="showError"-->
      <!--      ></ion-icon>-->
      <!--      <ion-label class="ion-text-wrap" color="danger" *ngIf="showError">-->
      <!--        <formly-validation-message [field]="field"></formly-validation-message>-->
      <!--      </ion-label>-->
    </ion-item>
    <radium-form-error-display
      [control]="field.formControl"
    ></radium-form-error-display>
  `,
})
export class FormlyWrapperComponent extends FieldWrapper {
  private _isMobile: boolean | null = null;

  constructor(private platform: Platform) {
    super();
  }

  get isMobile(): boolean {
    if (this._isMobile === null) {
      this._isMobile = this.platform.is('mobile');
    }
    return this._isMobile;
  }
}

/**  Copyright 2018 Google Inc. All Rights Reserved.
 Use of this source code is governed by an MIT-style license that
 can be found in the LICENSE file at http://angular.io/license */
